import React from "react";
import { Card } from "primereact/card";
import { useParams } from "react-router-dom";

import PermissionGate from "~/components/PermissionGate";
import CustomeButton from "../../../../components/Button/index";
import useLspPortfolioUpdate from "../../actions/useLspPortfolioUpdate";
import AccessDropDown from "../../../../components/AccessDropDown";
import AccessList from "../../../../components/lsp/customeraccess/AccessList";
import DeleteModal from "../../../UserAccess/components/DeleteModal";
import Notification from "../../../../components/entities/notification/Notification";
import usersIcon from "../../../../assets/images/users-icons.png";
import EmptyDataView from "../../../../components/nodataview";
import Loader from "../../../../components/loader/index";
import AuditSidebar from "../../../../components/audit-sidebar/AuditSidebar";
import API_ROUTES from "../../../../api-routes";

const LspPortfolio = () => {
  const { id } = useParams();

  const {
    statevalues,
    handleSetMenu,
    handleSelection,
    handleCloseMenu,
    searchEntity,
    handlSelectedService,
    openDeleteModal,
    closeDeleteModal,
    paginationOnchange,
    hanleChangeUpdateAccess,
    deleteUserAccess,
    handleDiscardUpdate,
    setUpdateMsg,
    setRemovedMsg,
    setAuditSidebarVisible,
  } = useLspPortfolioUpdate();

  const auditLabels = () => {
    return {
      create: "Entity Added",
      update: "Entity Information Updated",
      delete: "Entity Removed",
    };
  };

  return (
    <>
      {statevalues?.isAuditSidebarVisible && (
        <AuditSidebar
          heading="Customer Portfolio"
          endpoint={API_ROUTES.FETCH_LSP_CUSTOMER_AUDIT}
          id={id}
          labels={auditLabels}
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={statevalues?.isAuditSidebarVisible}
        />
      )}
      <Card className="card-onboard">
        <div className="formgrid grid flex justify-content-between mb-4">
          <p className="general-info">Customer Portfolio</p>
          <PermissionGate resource="entity" action="modify" resourceId={id}>
            <div className="flex gap-1">
              <>
                <CustomeButton
                  label="View History"
                  variant="outlined"
                  className="mr-2"
                  icon="pi pi-history"
                  iconPos="right"
                  onClick={() => setAuditSidebarVisible(true)}
                />
                <CustomeButton
                  label="Manage Access"
                  icon="pi pi-angle-down"
                  variant="contained"
                  iconPos="right"
                  onClick={(e) => handleSetMenu(e)}
                />
              </>
            </div>
          </PermissionGate>
        </div>

        <Notification
          message={statevalues.removedMsg}
          setMessage={setRemovedMsg}
          successMessage={statevalues.updateMsg}
          setSuccessMessage={setUpdateMsg}
        />

        <div className="formgrid grid">
          <div className="field col-12 mb-2 mt-3">
            {!statevalues?.accessList ? (
              <EmptyDataView
                Icon={<Loader />}
                // Header={"Adding Selection"}
                // Description={
                //   "Please don't close or refresh this page. We are adding your selection"
                // }
              />
            ) : statevalues?.accessList?.length > 0 ? (
              <AccessList
                allservices={statevalues.entityservices}
                accesslists={statevalues.accessList}
                openDeleteModal={openDeleteModal}
                paginationOnchange={paginationOnchange}
                paginationFisrt={statevalues?.accesspaginationFirst}
                paginationRows={statevalues?.accesspaginationRows}
                hanleChangeUpdateAccess={hanleChangeUpdateAccess}
                updatEntity={statevalues.updatEntity}
              />
            ) : (
              <EmptyDataView
                Icon={
                  <img
                    className="users-card-icon-img"
                    src={usersIcon}
                    alt="Users Icon"
                  />
                }
                Header={"No Customers Assigned"}
                Description={
                  <>
                    Let's build a list of all customers involved with this
                    partner.
                    <br />
                    Let's get started!
                  </>
                }
              />
            )}
            {statevalues?.updateBtnAvailbel && (
              <div className="col-12 drop-section-3 p-0">
                <div className="flex justify-content-end mt-3">
                  <CustomeButton
                    label="Discard"
                    variant="outlined"
                    className="mr-2"
                    onClick={handleDiscardUpdate}
                  />

                  <CustomeButton
                    label={!statevalues?.isLoadSelect && "Save Changes"}
                    variant="contained"
                    className="access-btn"
                    onClick={handleSelection}
                    loading={statevalues?.isLoadSelect}
                    disabled={
                      statevalues?.isLoadSelect ||
                      !statevalues?.selectedServices.length > 0
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <AccessDropDown
          refPanel={statevalues.refPanel}
          data={statevalues.entityLists}
          entityservices={statevalues.entityservices}
          handleSelection={handleSelection}
          selectedServices={statevalues.selectedServices}
          handleClose={handleCloseMenu}
          searchEntity={searchEntity}
          handlSelectedService={handlSelectedService}
          isLoading={statevalues?.isLoadSelect}
        />
        {statevalues?.isDeleteAccesModal && (
          <DeleteModal
            visible={statevalues?.isDeleteAccesModal}
            selectedEntity={statevalues?.deleteEntity}
            closeModal={closeDeleteModal}
            deleteUserAccess={deleteUserAccess}
            isLoading={statevalues?.isLoadSelect}
          />
        )}
      </Card>
    </>
  );
};

export default LspPortfolio;
